import { useParams } from 'react-router-dom';

import { Breadcrumb, BreadcrumbData } from '../../components/Breadcrumbs';
import { useSessions } from '../../hooks/useSwr';
import ProjectIcon from '../../icons/ProjectIcon';
import {
  appPublicDatasetsPath,
  appPublicPath,
  appSessionPath,
} from '../../utils/constants';

export function PublicProjectCrumb(props: Partial<BreadcrumbData>) {
  const { sessionId, datasetShareToken } = useParams();

  const session = useSessions(
    {
      id: sessionId ? [sessionId] : undefined,
      use_approx_stats: true,
      include_stats: true,
    },
    { datasetShareToken }
  );
  return (
    <Breadcrumb
      icon={<ProjectIcon />}
      name={session.data?.rows?.[0].name ?? ''}
      path={`/${appPublicPath}/${datasetShareToken}/${appPublicDatasetsPath}/${sessionId}/${appSessionPath}`}
      {...props}
    />
  );
}
